import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { faucetHttp } from "../utils/axiosProvider";
import { SuccessfulModal } from "../modals/SuccessfulModal";
import { toggleBodyScroll } from "../helper";
import { Config } from "../config";
import Loader from '../components/Loader';
import { LayoutContext } from "../contexts/LayoutContext";

export const Faucet = (props) => {
    const [ state, setState ] = useState({ ratelimitText: 'Request again in 24h', loader: false, ratelimit: false, successMessage: false, successModal: false, transactionUrl: 'https://explorer.hiro.so/', })
    const [ amount, _ ] = useState(101)
    const dispatch = useDispatch();
    const { layoutState, setLayoutState } = useContext(LayoutContext);
    const auth = useSelector((x) => x.auth);

    useEffect(() => {
        init();
    }, [auth?.authData?.stxAddress?.address]);

    const init = async () => {
        try {
            setState({ ...state, loader: true });
            const account = auth?.authData?.stxAddress?.address;
            if (account) {
                await faucetHttp.get('/user/faucet/check/' + account);
                setState({ ...state, loader: false,  successMessage: false, successModal: false, ratelimit: false });
            }
         } catch (error) {
            const message = error?.response?.data?.error?.message;
            setState({ ...state, loader: false, ratelimitText: message || 'Request Faucet', successMessage: false, ratelimit: true });
         }
    }

    const requestStx = async () => {
        setState({ ...state, loader: true });
        const account = auth?.authData?.stxAddress?.address;
        try {
           const result = (await faucetHttp.post('/user/faucet', { publicAddress: account }))?.data?.message || { txHash: '' };
           setState({ ...state, loader: false, ratelimitText: 'Request again in 24h', ratelimit: true, successMessage: true, successModal: true, transactionUrl: `${Config.url}txid/${result.txHash}?chain=${Config.name}`, });
        } catch (error) {
            setState({ ...state, loader: false, successMessage: false, ratelimit: true });
        }
    }

    return (
        <>
            <div className={`flex faucet-main direction-column`}>
                <div className="faucet-box">
                    <div className="header">
                        <h1 className="heading">STX Faucet</h1>
                    </div>
                    <div className="faucet-container">
                        <div className="faucet-from mb-2.5 md:mb-4">
                        <div className="flex items-center justify-between mb-2">
                            <p className="input-title">You’ll get { amount } STX in your testnet wallet</p>
                        </div>
                        <div className="input-box">
                                <input
                                    type="number" 
                                    value={amount}
                                    disabled
                                    readOnly
                                    className="amount m-0 mb-0" />
                                <div className="flex items-center justify-between" style={{ minWidth: 74 }}>
                                    <img style={{ width: 30 }} className="icon" src="https://raw.githubusercontent.com/velar-be/asset-hosting/main/stx.jpg" alt="" />
                                    <span>STX</span>
                                </div>
                            </div>
                        </div>

                        {!auth.isLoggedIn ? (
                            <button 
                                onClick={() => {
                                    setLayoutState({
                                        showSideBar: !layoutState.showSideBar,
                                        showWalletSidebar: !layoutState.showWalletSidebar
                                    })
                                }}
                                className="btn-warning btn-orange">Connect wallet</button>
                        ) : (
                            <>
                                {state.ratelimit ? (
                                    <button className="btn-warning btn-orange disabled">{ state.ratelimitText }</button>
                                ): (
                                    <button onClick={() => requestStx()} className="btn-warning btn-orange">
                                        { state.loader ? <Loader /> : 'Request Faucet'  }
                                    </button>
                                )}
                            </>
                        )}

                        <div className="flex items-center justify-center mt-3 mb-1">
                            <p className="input-title color-velar">Still Confused?  Join our discord and <a className="hand" href="https://discord.gg/velarbtc" target="_blank" style={{ color: 'rgba(248, 157, 51, 1)' }}>share your queries</a> </p>
                        </div>

                        <div className="flex items-center text-center justify-center mb-2">
                            <p className="input-title">Mint sBTC on <a style={{ color: 'rgba(248, 157, 51, 1)' }} target="_blank" href="https://bridge.sbtc.tech/">sBTC Bridge</a></p>
                        </div>
                    </div>
                </div>
            </div>
            {/* {(state.successMessage || false) && (
                <div className={`flex faucet-main direction-column mt-0`}>
                    <div className="faucet-box" style={{ background: 'rgba(248, 157, 51, 0.1)', padding: 10 }}>
                        <div className="faucet-container items-center direction-row flex m-0 p-3 mt-0" style={{ borderRadius: 10, marginBottom: 0, background: 'rgba(19, 14, 12, 1)' }}>
                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.0498 9C13.051 9.20386 12.9891 9.40311 12.8725 9.57033C12.7559 9.73754 12.5903 9.86451 12.3985 9.93375L9.17041 11.1212L7.98291 14.3469C7.91258 14.5379 7.78535 14.7028 7.61838 14.8193C7.45141 14.9357 7.25273 14.9982 7.04916 14.9982C6.84558 14.9982 6.6469 14.9357 6.47993 14.8193C6.31296 14.7028 6.18573 14.5379 6.11541 14.3469L4.92478 11.125L1.69853 9.9375C1.50749 9.86718 1.34261 9.73995 1.22615 9.57297C1.10969 9.406 1.04724 9.20732 1.04724 9.00375C1.04724 8.80017 1.10969 8.6015 1.22615 8.43452C1.34261 8.26755 1.50749 8.14032 1.69853 8.07L4.92666 6.8825L6.11416 3.65687C6.18448 3.46583 6.31171 3.30095 6.47868 3.18449C6.64565 3.06803 6.84433 3.00558 7.04791 3.00558C7.25148 3.00558 7.45016 3.06803 7.61713 3.18449C7.7841 3.30095 7.91133 3.46583 7.98166 3.65687L9.16916 6.885L12.3948 8.0725C12.5862 8.14076 12.7519 8.26651 12.8691 8.43253C12.9864 8.59856 13.0495 8.79675 13.0498 9ZM9.54978 3H10.5498V4C10.5498 4.13261 10.6025 4.25978 10.6962 4.35355C10.79 4.44732 10.9172 4.5 11.0498 4.5C11.1824 4.5 11.3096 4.44732 11.4033 4.35355C11.4971 4.25978 11.5498 4.13261 11.5498 4V3H12.5498C12.6824 3 12.8096 2.94732 12.9033 2.85355C12.9971 2.75978 13.0498 2.63261 13.0498 2.5C13.0498 2.36739 12.9971 2.24021 12.9033 2.14645C12.8096 2.05268 12.6824 2 12.5498 2H11.5498V1C11.5498 0.867392 11.4971 0.740215 11.4033 0.646447C11.3096 0.552678 11.1824 0.5 11.0498 0.5C10.9172 0.5 10.79 0.552678 10.6962 0.646447C10.6025 0.740215 10.5498 0.867392 10.5498 1V2H9.54978C9.41717 2 9.29 2.05268 9.19623 2.14645C9.10246 2.24021 9.04978 2.36739 9.04978 2.5C9.04978 2.63261 9.10246 2.75978 9.19623 2.85355C9.29 2.94732 9.41717 3 9.54978 3ZM15.0498 5H14.5498V4.5C14.5498 4.36739 14.4971 4.24021 14.4033 4.14645C14.3096 4.05268 14.1824 4 14.0498 4C13.9172 4 13.79 4.05268 13.6962 4.14645C13.6025 4.24021 13.5498 4.36739 13.5498 4.5V5H13.0498C12.9172 5 12.79 5.05268 12.6962 5.14645C12.6025 5.24021 12.5498 5.36739 12.5498 5.5C12.5498 5.63261 12.6025 5.75978 12.6962 5.85355C12.79 5.94732 12.9172 6 13.0498 6H13.5498V6.5C13.5498 6.63261 13.6025 6.75978 13.6962 6.85355C13.79 6.94732 13.9172 7 14.0498 7C14.1824 7 14.3096 6.94732 14.4033 6.85355C14.4971 6.75978 14.5498 6.63261 14.5498 6.5V6H15.0498C15.1824 6 15.3096 5.94732 15.4033 5.85355C15.4971 5.75978 15.5498 5.63261 15.5498 5.5C15.5498 5.36739 15.4971 5.24021 15.4033 5.14645C15.3096 5.05268 15.1824 5 15.0498 5Z" fill="url(#paint0_linear_2450_31386)"/>
                                <defs>
                                <linearGradient id="paint0_linear_2450_31386" x1="1.04724" y1="7.74908" x2="15.5498" y2="7.74908" gradientUnits="userSpaceOnUse">
                                <stop stopColor="#FDC830"/>
                                <stop offset="1" stopColor="#F37335"/>
                                </linearGradient>
                                </defs>
                            </svg>
                            <span className="ml-2 text-white">
                                Check your latest testnet faucet request here. <a href={state.transactionUrl} target="_blank" className="hand" style={{  color: 'rgba(248, 157, 51, 1)'}}>Visit explorer</a>
                            </span>
                        </div>
                    </div>
                </div>
            )} */}
            {(state.successModal) && (
                <SuccessfulModal
                    forType={'faucet'}
                    state={state}
                    message={`Airdropped ${amount} STX to your wallet.`}
                    onClose={() => {
                        setState({ ...state, successModal: false });
                        toggleBodyScroll(false)
                    }
                } />
            )}
        </>
    )
}
